import React from 'react'

export default function HomeFutureLastMonthPricesSliderLoading() {
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="border-muted-300 col-span-12 max-h-[214px] animate-pulse border-2 p-2 lg:col-span-4">
        <div className="mb-4 flex items-start justify-between ltr:flex-row-reverse">
          <div className="flex gap-2 ltr:flex-row-reverse ltr:text-end rtl:text-start">
            <div className="border-muted-300 h-10 w-10 border-2 bg-light" />
            <div className="space-y-1">
              <div className="bg-muted-300 h-4 w-20" />
              <div className="bg-muted-300 h-4 w-12" />
            </div>
          </div>
          <div className="bg-muted-300/20 border-muted-300 bg-muted-300 text-muted-300 flex justify-between whitespace-nowrap border-2 ltr:flex-row-reverse">
            <div className="h-6 w-14" />
            <div className="bg-muted-300 h-6 w-6 text-white" />
          </div>
        </div>
        <img
          alt="chart"
          src="/assets/icons/chart.svg"
          className="h-[128px] w-full object-cover object-top"
        />
      </div>
      <div className="border-muted-300 col-span-4 hidden max-h-[214px] animate-pulse border-2 p-2 lg:block">
        <div className="mb-4 flex items-start justify-between ltr:flex-row-reverse">
          <div className="flex gap-2 ltr:flex-row-reverse ltr:text-end rtl:text-start">
            <div className="border-muted-300 h-10 w-10 border-2 bg-light" />
            <div className="space-y-1">
              <div className="bg-muted-300 h-4 w-20" />
              <div className="bg-muted-300 h-4 w-12" />
            </div>
          </div>
          <div className="bg-muted-300/20 border-muted-300 bg-muted-300 text-muted-300 flex justify-between whitespace-nowrap border-2 ltr:flex-row-reverse">
            <div className="h-6 w-14" />
            <div className="bg-muted-300 h-6 w-6 text-white" />
          </div>
        </div>
        <img
          alt="chart"
          src="/assets/icons/chart.svg"
          className="h-[128px] w-full object-cover object-top"
        />
      </div>
      <div className="border-muted-300 col-span-4 hidden max-h-[214px] animate-pulse border-2 p-2 lg:block">
        <div className="mb-4 flex items-start justify-between ltr:flex-row-reverse">
          <div className="flex gap-2 ltr:flex-row-reverse ltr:text-end rtl:text-start">
            <div className="border-muted-300 h-10 w-10 border-2 bg-light" />
            <div className="space-y-1">
              <div className="bg-muted-300 h-4 w-20" />
              <div className="bg-muted-300 h-4 w-12" />
            </div>
          </div>
          <div className="bg-muted-300/20 border-muted-300 bg-muted-300 text-muted-300 flex justify-between whitespace-nowrap border-2 ltr:flex-row-reverse">
            <div className="h-6 w-14" />
            <div className="bg-muted-300 h-6 w-6 text-white" />
          </div>
        </div>
        <img
          alt="chart"
          src="/assets/icons/chart.svg"
          className="h-[128px] w-full object-cover object-top"
        />
      </div>
    </div>
  )
}
